<template>
    <div class="index-wrap">
        <div class="firstClass">
            <br/>
            <br/>
            <br/>
            <div class="headerWordClass">
                满&nbsp;分&nbsp;运&nbsp;动
            </div>
            <br/>
            <br/>
            <br/>
            <div class="wordClass">中国青少年运动健康领先品牌</div>
            <!--      controlsVisible 显示左右箭头-->
            <br/>
          <br/>
          <br/>
            <Carousel3d
                    :autoplay="true"
                    :autoplayTimeout="2500"
                    :perspective="20"
                    :display="5"
                    :animationSpeed="1000"
                    :space="spaceVal"
                    :width="376"
                    :height="658"
                    :controlsHeight="60"
                    :border="0"
            >
<!--     :clickable="false"         vue-carousel-3d/carousel-3d.common.js 中 注释掉209行 pauseAutoplay 方法体内容即可鼠标移入仍自动播放  删除3618行 goTo: function goTo() {方法-->
                <!--https://www.jianshu.com/p/8adab3d842e0  autoplayHoverPause-->
<!--              https://blog.csdn.net/memory_zzz/article/details/121079528-->
                <slide :index="0">
                    <img src="../assets/carouseImg/1.png" style="opacity: 0.8;">
                </slide>
                <slide :index="1">
                    <img src="../assets/carouseImg/2.png" style="opacity: 0.8;">
                </slide>
                <slide :index="2">
                    <img src="../assets/carouseImg/3.png" style="opacity: 0.8;">
                </slide>
                <slide :index="3">
                    <img src="../assets/carouseImg/4.png" style="opacity: 0.8;">
                </slide>
                <slide :index="4">
                    <img src="../assets/carouseImg/5.png" style="opacity: 0.8;">
                </slide>
            </Carousel3d>

        </div>
        <div>
            <div class="mainWordClass">
                <div class="wordClassChild">满&nbsp;分&nbsp;站&nbsp;位</div>
                <div class="wordClassChildLine"></div>
            </div>

            <div><!--第一层-->
                <div class="firstMainClass" style="float: left;width: 38%;height: 835px;background: #FFFFFF;position: relative">
                    <div style="height: 337px;width: 575px;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);border-bottom: 1px solid rgb(207, 207, 207);">
                        <div style="white-space:nowrap;position: absolute;top: 6%;font-size: 36px;font-weight: bold;font-family: Source Han Sans CN;color: #222222;line-height: 18px;">
                            坚决落实 “五育并举” 教育方针
                        </div>
                        <div style="position: absolute;top: 56px;height: 6px;width: 79px;background: rgb(248, 219, 0);"></div>
                        <div style="position: absolute;left: 228px;top: 38%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;font-size: 24px;">
                            要树立健康第一教育理念，开足开齐体育课
                        </div>
                        <div style="position: absolute;top: 44%;white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;font-size: 24px;">
                            体育锻炼多一些，“小胖墩”、“小眼镜”就少一些
                        </div>
                        <div style="position: absolute;left: 512px;top: 86%;transform: translate(-50%, -50%);white-space: nowrap;font-weight: bold;font-family: Source Han Sans CN;color: rgb(34, 34, 34);line-height: 36px;font-size: 24px;">
                            ——习近平
                        </div>
<!--                        <div class="middleSettingClass first_secondLineClass"></div>-->
                    </div>
                </div>

                <div class="homeClassOne" style="position: relative;float: left;width: 62%;height: 835px;">
                    <div class="middleSettingClass" style="height: 720px;width: 852px;position: absolute;top: 50%;left:50%;">
                        <!--transform: translate(-50%, -50%);-->
                        <img style="left:95px;position: absolute;background-size: 100% 100%"
                             src="../assets/pageOne/homeOneTree.png">
                        <div style="position: absolute;bottom: 86px;width: 100%;text-align: center;font-size: 30px;font-weight: 600;color: rgb(235, 206, 63);letter-spacing:2px">
                            满分课程设计
                        </div>
                        <div style="position: absolute; bottom: 46px; width: 100%;text-align: center;font-size:24px;font-weight:600;color: #F5F5F5;letter-spacing:3px;white-space:nowrap">
                            落实五育并举，坚持体能是体育之根
                        </div>
                        <div style="position: absolute; bottom: 14px; width: 104%;text-align: center;font-size:24px;font-weight:600;color: #F5F5F5;letter-spacing:3px">
                            精准落实2022版新课标“教会、勤练、常赛”要求，开足开齐开好体育课
                        </div>
                    </div>
                </div>
            </div>
            <div><!--第二层-->
                <div style="float: left;width: 38%;height: 835px;background: #F5F5F5;position: relative">
                    <div style="height: 360px;width: 575px;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);border-bottom: 1px solid rgb(207, 207, 207);">
                        <div style="white-space:nowrap;position: absolute;left: 47%;top: 6%;transform: translate(-50%, -50%);font-size: 36px;font-weight: bold;font-family: Source Han Sans CN;color: #222222;line-height: 18px;">
                            坚定推进国家教育数字化战略行动
                        </div>
                        <div style="position: absolute;top: 56px;height: 6px;width: 79px;transform: translate(-50%, -50%);left: 40px;background: rgb(248, 219, 0);"></div>
                        <div style="position: absolute;left: 205px;top: 38%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;font-size: 24px;">
                            要把教育信息化作为发展的战略制高点
                        </div>
                        <div style="position: absolute;left: 277px;top: 49%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;font-size: 24px;">
                            以教育信息化推动教育高质量发展，以教育信息化引
                        </div>
                        <div style="position: absolute;left: 73px;top: 60%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;font-size: 24px;">
                            领教育现代化
                        </div>
                        <div style="position: absolute;left: 512px;top: 86%;transform: translate(-50%, -50%);white-space: nowrap;font-weight: bold;font-family: Source Han Sans CN;color: rgb(34, 34, 34);line-height: 36px;font-size: 24px;">
                            ——怀进鹏
                        </div>
                    </div>
                </div>

                <div class="homeClassTwo" style="position: relative;float: left;width: 62%;height: 835px;">
                    <div style="height: 700px;width: 940px;position: absolute;top: 50%;left:50%;transform: translate(-50%, -50%)">
                        <!--transform: translate(-50%, -50%);-->
                        <img style="position: absolute;background-size: 100% 100%;height: 444px;top: 44px;"
                             src="../assets/pageOne/homeOneTable.png">
                        <div style="position: absolute;bottom: 86px;width: 100%;text-align: center;font-size: 30px;font-weight: 600;color: rgb(235, 206, 63);letter-spacing:2px">
                            满分科技系统
                        </div>
                        <div style="position: absolute; bottom: 46px; width: 100%;text-align: center;font-size:24px;font-weight:600;color: #F5F5F5;letter-spacing:3px;white-space: nowrap">
                            用“数字化+专业化”，让体育课有效、有趣、又有爱
                        </div>
                        <div style="position: absolute; bottom: 15px; width: 100%;text-align: center;font-size:24px;font-weight:600;color: #F5F5F5;letter-spacing:3px">
                            科技赋能，构建体育教育新范式
                        </div>
                    </div>
                </div>
            </div>
            <div><!--第三层-->
                <div style="float: left;width: 38%;height: 835px;background: #FFFFFF;position: relative">
                    <div style="height: 360px;width: 612px;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);border-bottom: 1px solid rgb(207, 207, 207);">
                        <div class="threeWordTitleClassSize" style="white-space:nowrap;position: absolute;top: 6%;transform: translate(-50%, -50%);font-size: 36px;font-weight: bold;font-family: Source Han Sans CN;color: #222222;line-height: 18px;">
                            中考评价改革推动学生体质健康提高
                        </div>
                        <div class="threeWordLineClassSize" style="position: absolute;top: 56px;height: 6px;width: 79px;transform: translate(-50%, -50%);background: rgb(248, 219, 0);"></div>
                        <div class="threeWordClassSize" style="position: absolute;left: 308px;top: 38%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;">
                            2023北京市中考改革方案发布，体育中考分值提至70分，
                        </div>
                        <div class="threeWordClassSize"  style="position: absolute;top: 49%;transform: translate(0%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;">
                            其中四、六、八年级完成过程性考核
                        </div><!--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
                        <div class="threeWordClassSize"  style="position: absolute;left: 303px;top: 60%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;">
                            各地市体育中考提分，内蒙古、吉林等地80分；山东、山
                        </div>
                        <div class="threeWordClassSize"  style="position: absolute;left: 303px;top: 71%;transform: translate(-50%, -50%);white-space: nowrap;font-family: Source Han Sans CN;font-weight: 400;color: rgb(76, 76, 76);line-height: 36px;">
                            西、安徽等多地60分，持续加大过程性体测考核分数占比
                        </div>
                        <!--            <div style="position: absolute;left: 404px;top: 141%;transform: translate(-50%, -50%);white-space: nowrap;font-weight: bold;font-family: Source Han Sans CN;color: rgb(34, 34, 34);line-height: 36px;font-size: 24px;">——怀进鹏</div>-->
<!--                        <div style="position: absolute;top: 359px;height: 1px;width: 545px;transform: translate(-50%, -50%);left: 230px;background: rgb(207, 207, 207);"></div>-->
                    </div>
                </div>

                <div class="homeClassThree" style="position: relative;float: left;width: 62%;height: 835px;">
                    <div style="height: 720px;width: 726px;position: absolute;top: 50%;left:50%;transform: translate(-50%, -50%);">
                        <!--transform: translate(-50%, -50%);-->
                        <img style="left:34px;position: absolute;background-size: 100% 100%"
                             src="../assets/pageOne/homeOneRound.png">
                        <div style="position: absolute;bottom: 86px;width: 100%;text-align: center;font-size: 30px;font-weight: 600;color: rgb(235, 206, 63);letter-spacing:2px">
                            满分实施效果
                        </div>
                        <div style="position: absolute; bottom: 46px; width: 100%;text-align: center;font-size:24px;font-weight:600;color: #F5F5F5;letter-spacing:3px;white-space: nowrap">
                            学生中考及体测提分效果显著，培养长期运动习惯与运动兴趣
                        </div>
                        <div style="position: absolute; bottom: 11px; width: 100%;text-align: center;font-size:24px;font-weight:600;color: #F5F5F5;letter-spacing:3px;white-space: nowrap">
                            切实提升青少年体能素质和身心健康水平
                        </div>
                        <div style="position: absolute; bottom: -9px; width: 100%;text-align: center;font-size:12px;font-weight:600;color: #F5F5F5;letter-spacing:3px;white-space: nowrap">
                            *数据节选自首都体育学院《2021 年人大附中西山学校满分智慧体能课运动干预效果分析报告》
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Carousel3d, Slide} from 'vue-carousel-3d';

    export default {
        components: {
            Carousel3d,
            Slide
        },
        mounted() {
            const _this = this;
            window.onresize = () => {
                return (() => {
                    _this.clientWidth= `${document.documentElement.clientWidth}`
                })()
            }
        },
        data() {
            return {
                clientWidth: 0,
                spaceVal:450,
            }
        },
        created() {
            this.windowWidth(document.documentElement.clientWidth)
        },
        methods: {
          delHandleMouseEnter() {
            alert()
            this.$refs.carousel.handleMouseEnter = () => {};
          },
            windowWidth(value) {
                this.clientWidth= value
                if(value<1500){
                    this.spaceVal=350
                }else{
                    this.spaceVal=450
                }
            }
        },
        // 这里优化了监听间隔，使用setTimeout，每500ms监听一次，这样操作避免了浏览器大小在持续变化时，连续监听带来的卡顿现象.
        watch: {
            clientWidth(val) {
                if(!this.timer) {
                    this.clientWidth= val
                    this.timer = true
                    let _this = this
                    setTimeout(function () {
                        _this.timer = false
                    }, 500)
                }
                // 这里可以添加修改时的方法
                this.windowWidth(val);
            }
        }
    }
</script>

<style scoped>

    .middleSettingClass{
        transform: translate(-50%, -50%);
    }
    .mainWordClass{
        background: #F5F5F5;
        width: 100%;
        height: 180px;
        position: relative
    }

    @media screen and (min-width: 0px) and (max-width: 1670px) {
        .threeWordClassSize {
            font-size: 22px;
            left:26px;
        }
    }
    @media screen and (min-width: 1671px)  {
        .threeWordClassSize {
            font-size: 24px;
        }
    }

    @media screen and (min-width: 0px) and (max-width: 1670px) {
        .threeWordTitleClassSize {
            left: 310px;
        }
    }
    @media screen and (min-width: 1671px)  {
        .threeWordTitleClassSize {
            left: 287px;
        }
    }

    @media screen and (min-width: 0px) and (max-width: 1670px) {
        .threeWordLineClassSize {
            left: 62px;
        }
    }
    @media screen and (min-width: 1671px)  {
        .threeWordLineClassSize {
            left: 40px;
        }
    }

    .firstClass {
        position: relative;
        width: 100%;
        height: 1100px;
        min-width: 500px;
        background-image: url('../assets/pageOne/homeBack.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .headerWordClass{
        text-align:center;
        font-size: 120px;
        font-weight: 800;
        color: #4C4C4C;
        /*font-family: Source Han Sans CN;*/
        line-height: 61px;
        font-family: 'heavy';
    }
    .wordClass {
        padding: 15px 18px;
        line-height: 1em;
        border-radius: 10px;
        transition: all .4s;
        background-color: #4C4C4C;
        width: 430px;
        text-align: center;
        font-size: 33px;
        color: #FFD900;
        margin: auto;
        font-family: 'heavy';
        /*font-family: Source Han Sans CN;*/
    }

    .wordClassChild {
        position: absolute; /* 设置绝对定位子元素 */
        top: 57px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 72px;
        font-weight: 800;
        font-family: 'heavy';
        /*font-family: Source Han Sans CN;*/
        color: #222222;
        line-height: 36px;
    }

    .wordClassChildLine {
        position: absolute; /* 设置绝对定位子元素 */
        bottom: 30px; /* 将子元素底部与父元素底部对齐 */
        height: 4px;
        width: 79px;
        transform: translate(-50%, -50%);
        left: 50%;
        background: #F8DB00;
    }

    .homeClassOne {
        background-image: url('../assets/pageOne/homeBackOne.png');
        background-size: 100% 100%;
    }

    .homeClassTwo {
        background-image: url('../assets/pageOne/homeBackTwo.png');
        background-size: 100% 100%;
    }

    .homeClassThree {
        background-image: url('../assets/pageOne/homeBackThree.png');
        background-size: 100% 100%;
    }

</style>

<style>
    .index-wrap {
        width: 100%;
        height: auto;
        overflow: hidden;
        position: relative;
    }

    .index-left-block .hr {
        margin-bottom: 20px;
    }

    .index-left-block h2 {
        background: #4fc08d;
        color: #fff;
        padding: 10px 15px;
        margin-bottom: 20px;
    }

    .index-left-block h3 {
        padding: 0 15px 5px 15px;
        font-weight: bold;
        color: #222;
    }

    .index-left-block ul {
        padding: 10px 15px;
    }

    .index-left-block li {
        padding: 5px;
    }

    .index-board-item h2 {
        font-size: 18px;
        font-weight: bold;
        color: #000;
        margin-bottom: 15px;
    }

    .VueCarousel-slide img {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue